import { apiUrl, fetchJson } from '../../apiBase';

export async function sendWelcomeTemplate(schoolId, parentId) {
  const url = apiUrl(`/admin/parents/${schoolId}/${parentId}/send-welcome`);
  const res = await fetchJson(url, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
  });
  if (!res.ok) throw new Error(await res.text());
}

export async function fetchWhatsappLink(schoolId) {
  const url = apiUrl(`/admin/whatsapp_link/${schoolId}`);
  const res = await fetchJson(url, { cache: 'no-store' });
  if (!res.ok) throw new Error(await res.text());
  return res.json();
}
